export default __webpack_public_path__ + "static/media/advcol3.0cf942c2.svg";